import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { SummaryOptionsStyled } from '../SummaryOptionsStyled';
import { rem } from 'polished';

export const SummaryOptionsStyledAC = styled(SummaryOptionsStyled)`
    &.withBorder {
        border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey2};
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h2};
            color: ${({ theme }) => theme.colors.grey5};
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }

    .descriptionWrapper {
        font-size: ${({ theme }) => theme.fontSizes.h4};
        color: ${({ theme }) => theme.colors.grey5};
    }

    .noOptionsWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .optionsWrapper {
        .next-btn,
        .back-btn {
            border-color: ${({ theme }) => theme.colors.red};

            &:disabled {
                border-color: ${({ theme }) => theme.colors.grey3};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey3};
                    }
                }
            }
        }

        .next-btn {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }

        .back-btn {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }
        }
    }
`;
